import React from 'react';
import { Component } from 'react';
import * as THREE from "three";
import { Scene, PerspectiveCamera, WebGLRenderer, AnimationMixer, AnimationClip, Object3D, Vector3 } from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import DataSevice from '../../../services/dataSevice';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
import { WrapperDataModel } from '../../../models/wrapperDataModel';
import { CSS2DRenderer, CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';
import Growl from '../../../common/components/growl/growl'
import InfoPanelComponent from './infoPanel.Component'
import * as HelperFunctions from '../../../common/helperFunctions';
import * as Constants from '../../../common/constants';
import { TagModel } from '../../../models/tagModel';
import { MainSceneInfoPanel, TagType } from '../../../common/enums';
import PieChartComponent from './pieChart.Component';
import { connect } from 'react-redux';
import ScenePopupComponent from '../../navigation/scenePopup.Component';
// import Fab from '@material-ui/core/Fab';
// import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import PauseIcon from '@material-ui/icons/Pause';
// import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";
// import Translate from '../../../common/translate';
import BarComponent from '../../common/barChart.Component';
import TWEEN from '@tweenjs/tween.js'
import axios from 'axios';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

// const animationTheme = createMuiTheme({
//   overrides: {
//     MuiButtonBase: {
//       root: {
//         color: '#3dcd58',
//         padding: '5px'
//       }
//     },
//     MuiFab: {
//       root: {
//         '&:hover': {
//           backgroundColor: undefined,
//           boxShadow: '0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12)'
//         },
//         backgroundColor: undefined,
//         boxShadow: 'none',
//         color: '#3dcd58',
//       },
//       extended: {
//         padding: '5px'
//       }
//     }
//   }
// });

interface IProps {
  history?: any,
  lang: string,
  //animationState: string
}

interface IState {
  isLoading: boolean;
  loadingPercent: number;
  allData: Array<WrapperDataModel>;
  isZoomIn: boolean;
  isPopupVisivle: boolean;
  popupContent: any;
  popupTitle: any;
  oldDataTags: Array<TagModel>;
  isDataUpdated: boolean;
  isAnimationOn: boolean;
  roofOpen: boolean;
  arePanelsVisible: boolean;
  afterAnimPoint: any;
}

class MainSceneComponent extends Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      isLoading: true,
      loadingPercent: 0,
      allData: new Array<WrapperDataModel>(0),
      isZoomIn: false,
      isPopupVisivle: false,
      popupContent: null,
      popupTitle: null,
      oldDataTags: new Array<TagModel>(0),
      isDataUpdated: false,
      isAnimationOn: true,
      roofOpen: false,
      arePanelsVisible: false,
      afterAnimPoint: null
    }
  }

  container: any;
  scene: Scene = new Scene();
  camera: PerspectiveCamera = new PerspectiveCamera(40, window.innerWidth / window.innerHeight, 0.1, 30000);
  renderer: WebGLRenderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  controls: any;
  loadingManager: any;
  animationFrame: any;
  dataService = new DataSevice();
  totalBuildingConsumption = React.createRef<HTMLDivElement>();
  energyDistribution = React.createRef<HTMLDivElement>();
  weatherStation = React.createRef<HTMLDivElement>();
  common = React.createRef<HTMLDivElement>();
  animationPanel = React.createRef<HTMLDivElement>();
  labelRenderer: CSS2DRenderer = new CSS2DRenderer();
  interval: any;
  growl: any;
  boxSize: number = 0;
  mixer: AnimationMixer = new AnimationMixer(new Object3D());
  clock = new THREE.Clock();
  animations: Array<AnimationClip> = new Array<AnimationClip>(0);
  points: THREE.Points;
  mowerPointsArray: Array<THREE.Points> = new Array<THREE.Points>(0);

  mouse: THREE.Vector2 = new THREE.Vector2();
  raycaster: THREE.Raycaster = new THREE.Raycaster();
  clickableObjects: Array<Object3D> = new Array<Object3D>(0);
  currentIntersectionObject: any;
  currentIntersectionObjectsGroup: Array<any> = new Array<any>(0);

  componentDidMount() {
    this.initLoading();
    this.initScene();
    this.initObjects();
    this.animate();
    window.addEventListener("resize", this.onWindowResize, false);
    window.addEventListener('wheel', this.onCameraZoom, true);
    window.addEventListener('touchmove', this.onCameraZoom, true);

    window.addEventListener('mousemove', this.onDocumentMouseMove, false);
    window.addEventListener('click', this.onDocumentMouseClick, false);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.animationFrame);
    clearInterval(this.interval);
    //this.resourceTracker.dispose();
    this.onDestroy();

    window.removeEventListener('wheel', this.onCameraZoom, true);
    window.removeEventListener('touchmove', this.onCameraZoom, true);
    window.removeEventListener("resize", this.onWindowResize, false);

    window.removeEventListener('mousemove', this.onDocumentMouseMove, false);
    window.removeEventListener('click', this.onDocumentMouseClick, false);
  }

  initLoading = () => {
    this.loadingManager = new THREE.LoadingManager(
      () => {
        const loadingScreen = document.getElementById('loading-screen');
        if (loadingScreen) loadingScreen.classList.add('fade-out');
        if (loadingScreen) loadingScreen.addEventListener('transitionend', this.onTransitionEnd);
      },
      (url, itemsLoaded, itemsTotal) => {
        this.setState({ loadingPercent: Math.round(itemsLoaded / itemsTotal * 100) });
      },
      (url) => {
        console.log('There was an error loading ' + url);
      }
    );
  }

  onTransitionEnd = (event: any) => {
    this.setState({ isLoading: false }, () => this.getData());
    event.target.removeEventListener('transitionend', event.target);
  }

  initScene = () => {
    // Scene        
    //this.scene.background = new THREE.Color(0xe8f9fc);

    // var axesHelper = new THREE.AxesHelper(20000);
    // this.scene.add(axesHelper);

    // Camera
    this.camera.position.x = -3000; // -2000
    this.camera.position.y = 4000; // 20000
    this.camera.position.z = -1500; // 4000

    // Renderer    
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.autoClear = false;
    this.renderer.setClearColor(0x000000, 0.0);
    this.renderer.shadowMap.enabled = true;
    this.renderer.shadowMap.type = THREE.PCFShadowMap;
    this.container.appendChild(this.renderer.domElement);

    this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
    this.labelRenderer.domElement.style.position = 'absolute';
    this.labelRenderer.domElement.style.top = "0";
    this.container.appendChild(this.labelRenderer.domElement)

    // RayCaster
    this.raycaster = new THREE.Raycaster();
    this.raycaster.params = {
      Mesh: {},
      Line: { threshold: 0 },
      LOD: {},
      Points: { threshold: 1 },
      Sprite: {}
    };

    // Controls
    this.controls = new OrbitControls(this.camera, this.container);

    // Lights
    const light1 = new THREE.DirectionalLight(0xffffff, 2);
    light1.position.set(-10000, 10000, -10000); // (-10000, 10000, 10000);
    light1.castShadow = true;
    light1.shadow.bias = 0.001;
    light1.shadow.mapSize.width = 8192;
    light1.shadow.mapSize.height = 8192;
    light1.shadow.radius = 3;
    this.scene.add(light1);
    // var light1Helper = new THREE.DirectionalLightHelper(light1, 50);
    // this.scene.add(light1Helper);

    const cam = light1.shadow.camera;
    cam.near = 3000;
    cam.far = 30000;
    cam.left = -16000;
    cam.right = 16000;
    cam.top = 16000;
    cam.bottom = -16000;

    // const cameraHelper = new THREE.CameraHelper(cam);
    // this.scene.add(cameraHelper);

    var light2 = new THREE.AmbientLight(0xffffff, 0.7);
    light2.position.set(10000, 10000, 10000);
    this.scene.add(light2);
  }

  initObjects = () => {

    const gltfLoader = new GLTFLoader(this.loadingManager);
    let dracoloader = new DRACOLoader();
    dracoloader.setDecoderPath(Constants.dracoJS)
    gltfLoader.setDRACOLoader(dracoloader);
    gltfLoader.load(Constants.modelMainScene, (gltf: any) => {
      const root = gltf.scene;
      this.scene.add(root);

      root.traverse((obj: any) => {
        if (obj.castShadow !== undefined) {
          obj.castShadow = true;
          obj.receiveShadow = true;
        }
      });
      // var boxHelper = new THREE.BoxHelper(root);
      // this.scene.add(boxHelper);


      //console.log(HelperFunctions.dumpObject(root).join('\n'));

      // animations
      this.mixer = new THREE.AnimationMixer(root);
      let oldAnimationsArray: Array<AnimationClip> = gltf.animations;
      let newAnimationsArray: Array<AnimationClip> = new Array<AnimationClip>(0);

      oldAnimationsArray.forEach(r => {
        let mowerTracksFront = r.tracks.filter(r => r.name.startsWith(Constants.mainScene_MowerFront));
        let mowerTracksBack = r.tracks.filter(r => r.name.startsWith(Constants.mainScene_MowerBack));
        let roofTracks = r.tracks.filter(r =>
          r.name.startsWith(Constants.mainScene_BigRoofAnimation) || r.name.startsWith(Constants.mainScene_SmallRoofAnimation) ||
          r.name.startsWith(Constants.mainScene_AnimationSmallRoof) || r.name.startsWith(Constants.mainScene_AnimationRoofElements));

        let busTracks = r.tracks.filter(r => !r.name.startsWith("Mower") && !r.name.startsWith(Constants.mainScene_AnimationSmallRoof) &&
          !r.name.startsWith(Constants.mainScene_SmallRoofAnimation) && !r.name.startsWith(Constants.mainScene_BigRoofAnimation) &&
          !r.name.startsWith(Constants.mainScene_AnimationRoofElements));


        let busAnimation: AnimationClip = new AnimationClip("Bus_Animation", r.duration, busTracks);
        let mowerAnimationsFront: AnimationClip = new AnimationClip("Mower_Animation_Front", r.duration, mowerTracksFront);
        let mowerAnimationsBack: AnimationClip = new AnimationClip("Mower_Animation_Back", r.duration, mowerTracksBack);
        let animationRoof: AnimationClip = new AnimationClip("Animation_Roof", r.duration, roofTracks);

        newAnimationsArray.push(busAnimation);
        newAnimationsArray.push(mowerAnimationsFront);
        newAnimationsArray.push(mowerAnimationsBack);
        newAnimationsArray.push(animationRoof);
      });

      this.animations = newAnimationsArray;

      let mowerAnim = THREE.AnimationClip.findByName(newAnimationsArray, "Mower_Animation_Front");
      let mowers = this.mixer.clipAction(mowerAnim);
      mowers.play();

      let mowerAnimBack = THREE.AnimationClip.findByName(newAnimationsArray, "Mower_Animation_Back");
      let mowersBack = this.mixer.clipAction(mowerAnimBack);
      mowersBack.play();

      let busAnim = THREE.AnimationClip.findByName(newAnimationsArray, "Bus_Animation");
      let bus = this.mixer.clipAction(busAnim);
      bus.play();

      const box = new THREE.Box3().setFromObject(root);

      this.boxSize = box.getSize(new THREE.Vector3()).length();
      const boxCenter = box.getCenter(new THREE.Vector3());

      // set the camera to frame the box
      this.frameArea(this.boxSize * 0.5, this.boxSize, boxCenter);

      // update the Trackball controls to handle the new size
      this.controls.maxPolarAngle = Math.PI / 2.2;
      this.controls.minPolarAngle = Math.PI / 4;
      this.controls.maxDistance = this.boxSize * 1;
      this.controls.minDistance = this.boxSize * 0.1;
      this.controls.target.copy(boxCenter);
      this.controls.enableDamping = true;
      this.controls.dampingFactor = 0.05;
      this.controls.rotateSpeed = 0.3;
      this.controls.zoomSpeed = 0.7;
      this.controls.update();

      this.addPoints();

      this.addClickableObjects();
      // this.interval = setInterval(() => {
      //   this.getData()
      // }, 10000);
    });
  }



  openRoof = () => {
    let roofAnim = THREE.AnimationClip.findByName(this.animations, Constants.mainScene_AnimationRoof);
    if (roofAnim) {
      let roof = this.mixer.clipAction(roofAnim);
      roof.reset();
      roof.repetitions = 1;
      roof.clampWhenFinished = true;
      roof.play();
      this.setState({ roofOpen: true });

      if (this.state.afterAnimPoint) {
        let point = { ...this.state.afterAnimPoint };
        let roofDot = this.scene.getObjectByName(point.hidePoint);
        let roofDotF = this.scene.getObjectByName(point.hidePoint + 'First');
        let roofDotS = this.scene.getObjectByName(point.hidePoint + 'Second');
        if (roofDot && roofDotS && roofDotF) {
          this.scene.remove(roofDot);
          this.scene.remove(roofDotF);
          this.scene.remove(roofDotS);
        }

        setTimeout(() => {
          HelperFunctions.addInteractivePoints(point.position, point.pointName,
            point.route !== null ? () => this.onNavigationCLick(point.route) : this[point.method], this.scene);
        }, 10000);
      }
    }
  }

  getLabel = (name: string) => {
    switch (name) {
      case "TotalConsumption":
        return this.totalBuildingConsumption;
      case "EnergyDistribution":
        return this.energyDistribution;
      case "WeatherStation":
        return this.weatherStation;
      case "CommonLabel":
        return this.common;
      default:
        return this.totalBuildingConsumption;
    }
  }

  removeFromScene = (objectName: string, withLine: boolean) => {
    let objectInScene = this.scene.getObjectByName(objectName);
    if (objectInScene) {
      this.scene.remove(objectInScene);
    }
    if (withLine) {
      this.removeFromScene(objectName + 'Line', false);
      this.removeFromScene(objectName + 'GreenDot', false);
      this.removeFromScene(objectName + 'FirstDot', false);
      this.removeFromScene(objectName + 'SecondDot', false);
    }
  }

  addPoints = () => {
    var vertices = new THREE.SphereGeometry(70).vertices;
    var geometry = new THREE.BufferGeometry().setFromPoints(vertices);
    let material = new THREE.PointsMaterial({
      color: 0x3dcd58,
      size: 50,
      blending: THREE.AdditiveBlending,
      transparent: true,
      depthTest: true,
      sizeAttenuation: true,
      opacity: 0.8
    });

    let mowerBack = this.scene.getObjectByName(Constants.mainScene_MowerBack);
    if (mowerBack) {
      let pointsM1 = new THREE.Points(geometry, material);
      mowerBack.add(pointsM1);
      pointsM1.position.x = -150;
      this.mowerPointsArray.push(pointsM1)
    }

    let mowerForntLeft = this.scene.getObjectByName(Constants.mainScene_MowerFrontLeft);
    if (mowerForntLeft) {
      let pointsM2 = new THREE.Points(geometry, material);
      mowerForntLeft.add(pointsM2);
      pointsM2.position.x = -150;
      this.mowerPointsArray.push(pointsM2)
    }

    let mowerForntCenter = this.scene.getObjectByName(Constants.mainScene_MowerFrontCenter);
    if (mowerForntCenter) {
      let pointsM3 = new THREE.Points(geometry, material);
      mowerForntCenter.add(pointsM3);
      pointsM3.position.x = -150;
      this.mowerPointsArray.push(pointsM3)
    }

    let mowerForntRight = this.scene.getObjectByName(Constants.mainScene_MowerFrontRight);
    if (mowerForntRight) {
      let pointsM4 = new THREE.Points(geometry, material);
      mowerForntRight.add(pointsM4);
      pointsM4.position.x = -150;
      this.mowerPointsArray.push(pointsM4)
    }
  }

  getData = () => {
    this.setState({ isDataUpdated: false })
    this.dataService.getAllTagsFakeData().then(
      (data: any) => {
        this.processData(data);
      }
    ).catch(
      (error: any) => {
        this.growl.show({ severity: 'error', summary: error.message });
      });
  }

  processData = (data) => {
    axios.get('/assets/config.json') // JSON File Path
      .then(res => {
        if (res.data) {
          let mainScene = res.data.scenes.find(r => r['mainScene']).mainScene;
          if (mainScene) {
            let infoPanels = mainScene.infoPanels;
            let wrappedData: Array<WrapperDataModel> = new Array<WrapperDataModel>(0);
            let newDataTags: Array<TagModel> = data;
            let oldDataTags = [...this.state.oldDataTags];
            for (let infoPanel of infoPanels) {
              let newData: WrapperDataModel = new WrapperDataModel();
              newData.isToggable = infoPanel.toggle;
              newData.infoPanelType = infoPanel.content.type;
              newData.dataTypeId = MainSceneInfoPanel[`${infoPanel.title}`];
              newData.tagsData = new Array<TagModel>(0);

              let infoPanelTagTypes: Array<TagType> = new Array<TagType>(0);
              for (let item of infoPanel.content.items) {
                infoPanelTagTypes.push(TagType[`${item.tagType}`])
              }

              infoPanelTagTypes.map(t => {
                let newTag: any = newDataTags.find(f => f.tagType === t);
                if (newTag) {
                  let oldTag = oldDataTags.find(f => f.tagType === t);
                  if (oldTag) {
                    newTag.isValueChanged = newTag.value !== oldTag.value ? true : false;
                  } else {
                    newTag.isValueChanged = false;
                  }
                } else {
                  newTag = new TagModel();
                  newTag.value = 'N/A';
                }
                newData.tagsData.push(newTag);
                return 0;
              });
              wrappedData.push(newData);

              this.removeFromScene(infoPanel.title, true);
              this.addInfoPanel(infoPanel.position, infoPanel.panelOffset, this.getLabel(infoPanel.title), true, infoPanel.title);
            }

            let points = mainScene.interactivePoints;
            for (let point of points) {
              if (!point.visibleAfterAnimation) {
                HelperFunctions.addInteractivePoints(point.position, point.pointName,
                  point.route !== null ? () => this.onNavigationCLick(point.route) : this[point.method], this.scene);
              }
              else {
                this.setState({ afterAnimPoint: point });
              }
            }

            this.setState({ allData: wrappedData, oldDataTags: newDataTags, isDataUpdated: true, arePanelsVisible: true });
          }
        }
      })
      .catch(function (error) {
        console.log(error);
      });

    // let wrappedData: Array<WrapperDataModel> = new Array<WrapperDataModel>(0);
    // let newDataTags: Array<TagModel> = data;
    // const mainSceneInfoPanel = HelperFunctions.getEnumKeys(MainSceneInfoPanel);
    // let oldDataTags = [...this.state.oldDataTags];

    // mainSceneInfoPanel.map(k => {
    //   let newData: WrapperDataModel = new WrapperDataModel();
    //   newData.dataTypeId = parseInt(MainSceneInfoPanel[k]);
    //   newData.tagsData = new Array<TagModel>(0);

    //   let infoPanelTagTypes: Array<TagType> = HelperFunctions.getTagVisualisationType(MainSceneInfoPanel[k]);

    //   infoPanelTagTypes.map(t => {
    //     let newTag: any = newDataTags.find(f => f.tagType === t);
    //     if (newTag) {
    //       let oldTag = oldDataTags.find(f => f.tagType === t);
    //       if (oldTag) {
    //         newTag.isValueChanged = newTag.value !== oldTag.value ? true : false;
    //       } else {
    //         newTag.isValueChanged = false;
    //       }
    //     } else {
    //       newTag = new TagModel();
    //       newTag.value = 'N/A';
    //     }
    //     newData.tagsData.push(newTag);
    //     return 0;
    //   });
    //   wrappedData.push(newData);
    //   return 0;
    // });

    //this.setState({ allData: wrappedData, oldDataTags: newDataTags, isDataUpdated: true });
  }

  frameArea = (sizeToFitOnScreen: any, boxSize: any, boxCenter: any) => {
    const halfSizeToFitOnScreen = sizeToFitOnScreen * .5;
    const halfFovY = THREE.MathUtils.degToRad(this.camera.fov * .5);
    const distance = halfSizeToFitOnScreen / Math.tan(halfFovY);
    // compute a unit vector that points in the direction the camera is now
    // in the xz plane from the center of the box
    const direction = (new THREE.Vector3())
      .subVectors(this.camera.position, boxCenter)
      .multiply(new THREE.Vector3(1, 30, 1.8))
      .normalize();

    // move the camera to a position distance units way from the center
    // in whatever direction the camera was from the center already
    this.camera.position.copy(direction.multiplyScalar(distance * 1.2).add(boxCenter)); // 1.3

    // pick some near and far values for the frustum that
    // will contain the box.
    this.camera.near = boxSize / 100;
    this.camera.far = boxSize * 100;

    this.camera.updateProjectionMatrix();

    //console.log(this.camera);

    // point the camera to look at the center of the box
    this.camera.lookAt(boxCenter.x, boxCenter.y, boxCenter.z);
    // var helper = new THREE.CameraHelper(this.camera);
    // this.scene.add(helper);
  }

  addInfoPanel = (position: any, panelOffset: any, label: any, withLine: boolean, infoPanelName: string) => {
    let posMat: Vector3 = new Vector3(position.x, position.y, position.z);
    const elem = label.current
    var infoPanel: any;
    if (elem != null) {
      infoPanel = new CSS2DObject(elem);
      infoPanel.position.set(posMat.x + panelOffset.x, posMat.y + panelOffset.y, posMat.z + panelOffset.z);
      infoPanel.name = infoPanelName;
      this.scene.add(infoPanel);
    }
    //var controls = new OrbitControls(this.camera, this.labelRenderer.domElement);
    if (withLine) {
      let greendot = document.createElement('div');
      greendot.setAttribute('class', 'green-dot fade-in');
      let customGreenDot = new CSS2DObject(greendot);
      customGreenDot.position.set(posMat.x, posMat.y, posMat.z);
      customGreenDot.name = infoPanelName + 'GreenDot';
      this.scene.add(customGreenDot);

      let dotEl = document.createElement('div');
      dotEl.setAttribute('class', 'custom-dot fade-in');
      let customDot = new CSS2DObject(dotEl);
      customDot.position.set(posMat.x, posMat.y, posMat.z);
      customDot.name = infoPanelName + 'FirstDot';
      this.scene.add(customDot);

      let dotEl2 = document.createElement('div');
      dotEl2.setAttribute('class', 'custom-dot-two fade-in');
      let customDot2 = new CSS2DObject(dotEl2);
      customDot2.position.set(posMat.x, posMat.y, posMat.z);
      customDot2.name = infoPanelName + 'SecondDot';
      this.scene.add(customDot2);

      var lineMaterial = new THREE.LineBasicMaterial({
        color: 0x3dcd58,
        depthTest: false
      });

      var tubeGeometry = new THREE.TubeGeometry(
        new THREE.CatmullRomCurve3([posMat, infoPanel.position]),
        512,// path segments
        10,// THICKNESS
        8, //Roundness of Tube
        false //closed
      );

      let tubeBufferGeomtry = new THREE.BufferGeometry().fromGeometry(
        tubeGeometry
      );

      var line = new THREE.Line(tubeBufferGeomtry, lineMaterial);
      line.name = infoPanelName + 'Line';
      this.scene.add(line);
      HelperFunctions.trackOriginalOpacities(line);
      HelperFunctions.fadeMesh(line, 'in', {
        duration: 1200,
        easing: TWEEN.Easing.Quintic.InOut
      })
    }

  }

  animate = () => {
    var delta = this.clock.getDelta();
    if (this.mixer) {
      this.mixer.update(delta);
    }

    if (this.state.isAnimationOn) {
      if (this.animations && this.animations.length > 0) {
        let busAnim = THREE.AnimationClip.findByName(this.animations, "Bus_Animation");
        this.mixer.clipAction(busAnim).paused = false;
      }

    } else {
      if (this.animations && this.animations.length > 0) {
        let busAnim = THREE.AnimationClip.findByName(this.animations, "Bus_Animation");
        this.mixer.clipAction(busAnim).paused = true;
      }
    }

    this.mowerPointsArray.forEach(p => {
      p.rotation.y += 0.3;
    });
    TWEEN.update();
    this.animationFrame = requestAnimationFrame(this.animate);
    this.controls.update();

    // this.checkClickableIntersections();

    this.renderer.render(this.scene, this.camera);
    this.labelRenderer.render(this.scene, this.camera);
  }

  addClickableObjects = () => {
    this.scene.traverse(c => {
      if (Constants.mainScene_SelectableObjectsArray.some(o => c.name.startsWith(o))) {
        this.clickableObjects.push(c);
      }
    })
  }

  onDocumentMouseMove = (event: any) => {
    this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    this.mouse.y = - (event.clientY / window.innerHeight) * 2 + 1;
  }

  onDocumentMouseClick = (event) => {
    event.preventDefault();
    // this.raycaster.setFromCamera(this.mouse, this.camera);

    // let intersections = this.raycaster.intersectObjects(this.clickableObjects);
    // let intersection = (intersections.length) > 0 ? intersections[0] : null;
    // if (intersection && intersection.object &&
    //   Constants.mainScene_ClickableObjectArray.some(o => (intersection && intersection.object.name.startsWith(o)))
    // ) {
    //   //Pause/unpause mower animation
    //   if (intersection.object.name.startsWith(Constants.mainScene_MowerAnimationObjClick)) {
    //     let mowerAnim = THREE.AnimationClip.findByName(this.animations, Constants.mainScene_MowerAnimationBack);
    //     if (mowerAnim) {
    //       this.mixer.clipAction(mowerAnim).paused = !this.mixer.clipAction(mowerAnim).paused;
    //       this.mowerPointsArray[0].visible = !this.mowerPointsArray[0].visible;
    //     }
    //   }
    //   //Start roof animation
    //   if (intersection.object.name.startsWith(Constants.mainScene_BigRoofAnimation)) {
    //     let roofAnim = THREE.AnimationClip.findByName(this.animations, Constants.mainScene_AnimationRoof);
    //     if (roofAnim) {
    //       let roof = this.mixer.clipAction(roofAnim);
    //       roof.reset();
    //       roof.repetitions = 1;
    //       roof.clampWhenFinished = true;
    //       roof.play();
    //     }
    //   }
    //   //Enter main hall
    //   if (Constants.mainScene_MainHallBoxObjectsArray.some(o => (intersection && intersection.object.name.startsWith(o)))) {
    //     this.onNavigationCLick("/main-hall");
    //   }

    //   //Enter etrance
    //   if (Constants.mainScene_MainHallEntarance.some(o => (intersection && intersection.object.name.startsWith(o))))
    //     this.onNavigationCLick("/entrance");
    // }
  }

  // checkClickableIntersections = () => {
  //   this.raycaster.setFromCamera(this.mouse, this.camera);

  //   let intersections = this.raycaster.intersectObjects(this.clickableObjects);
  //   let intersection = intersections.length > 0 ? intersections[0] : null;
  //   if (intersection) {
  //     this.container.style.cursor = "pointer";

  //     // Set emissive to default (black) before reseting it agian because we have case of mouse move from clickabel to clikcable. 
  //     if (this.currentIntersectionObject) {
  //       this.currentIntersectionObject.material.emissive.setHex("0x000000");
  //     }

  //     if (this.currentIntersectionObjectsGroup && this.currentIntersectionObjectsGroup.length > 0) {
  //       this.removeMouseHoverEffectFromObjectArray();
  //     }

  //     if (Constants.mainScene_SmallRoofGroup.some(o => (intersection && intersection.object.name.startsWith(o)))) {
  //       this.addMouseHoverEffectToObjectArray(Constants.mainScene_SmallRoofGroup);
  //       return;
  //     }

  //     this.currentIntersectionObject = intersection.object;
  //     let objMat = this.currentIntersectionObject.material.clone();
  //     objMat.emissive.setHex("0x444444");

  //     this.currentIntersectionObject.material = objMat;
  //   } else {
  //     this.container.style.cursor = "";

  //     if (this.currentIntersectionObject) {
  //       this.currentIntersectionObject.material.emissive.setHex("0x000000");
  //     }

  //     if (this.currentIntersectionObjectsGroup && this.currentIntersectionObjectsGroup.length > 0) {
  //       this.removeMouseHoverEffectFromObjectArray();
  //     }
  //   }
  // }

  // addMouseHoverEffectToObjectArray = (objectsArray) => {
  //   objectsArray.forEach(o => {
  //     let currentObj: any = this.scene.getObjectByName(o);
  //     if (currentObj) {
  //       this.currentIntersectionObjectsGroup.push(currentObj);

  //       let objMat = currentObj.material.clone();
  //       objMat.emissive.setHex("0x444444");

  //       currentObj.material = objMat;
  //     }
  //   });
  // }

  // removeMouseHoverEffectFromObjectArray = () => {
  //   this.currentIntersectionObjectsGroup.forEach(o => {
  //     o.material.emissive.setHex("0x000000");
  //   });

  //   this.currentIntersectionObjectsGroup = new Array<any>(0);
  // }

  onWindowResize = () => {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
  }

  onClickDetails = (houseId: number) => {
    //window.location.href = `/DetailScene?houseId=${houseId}`;
    this.props.history.push(`/DetailScene?houseId=${houseId}`);
  }

  onNavigationCLick = (path: string) => {
    this.props.history.push(path);
  }

  onCameraZoom = () => {
    let zoomValue = this.camera.position.length();

    if (zoomValue < this.boxSize * .7) {
      if (!this.state.isZoomIn) {
        this.setState({
          isZoomIn: true
        });
      }
    } else {
      if (this.state.isZoomIn) {
        this.setState({
          isZoomIn: false
        });
      }
    }
  }

  onDestroy = () => {
    for (let anim of this.animations) {
      this.mixer.uncacheClip(anim);
    }

    HelperFunctions.disposeResource(this.scene);
    // if (this.scene) {
    //   this.scene.dispose();
    //   //@ts-ignore
    //   this.scene = undefined;
    // }

    // this.renderer.forceContextLoss();
    // this.renderer.renderLists.dispose();
    // this.renderer.dispose();
    // //@ts-ignore
    // this.renderer.domElement = undefined;
    // //@ts-ignore
    // this.renderer = undefined;
  }

  openChartPopup = (tagsData: Array<TagModel>) => {
    var chart = <div>
      <PieChartComponent data={tagsData} isBig={true} />
    </div>;

    var title = HelperFunctions.getEnumLabel(MainSceneInfoPanel.EnergyDistribution, MainSceneInfoPanel, true)
    this.setState({ isPopupVisivle: true, popupContent: chart, popupTitle: title })
  }

  openBarPopup = (tagNumber: number) => {
    var barChart = <BarComponent tagNumber={tagNumber} lang={this.props.lang} width={800} height={400} paginator={true} popupChart={true} />;
    var title = (
      <div style={{ marginBottom: 10, paddingTop: 5 }}>{HelperFunctions.getEnumLabel(tagNumber, TagType, true)}</div>);
    this.setState({ isPopupVisivle: true, popupContent: barChart, popupTitle: title })
  }

  handleCancelPopupButton = () => {
    this.setState({ isPopupVisivle: false })
  }

  handleAnimationButtonClick = () => {
    this.setState({
      isAnimationOn: !this.state.isAnimationOn
    })
  }

  render() {
    return (
      <>
        <Growl ref={(el: any) => this.growl = el} />

        {this.state.isLoading ?
          <section id="loading-screen">
            <div id="loader"></div>
            <div id="loader-percent">{this.state.loadingPercent} %</div>
          </section> : null}

        <div ref={ref => (this.container = ref)}>
          <>
            {/* <ul className="submenu">
              <li
                onClick={() => this.onNavigationCLick('/main-hall')}
                onTouchStartCapture={() => this.onNavigationCLick('/main-hall')}>
                Main Hall
                  <FontAwesomeIcon className="submenu-icon" icon={faChevronRight} />
              </li>
            </ul> */}

            {/* <div className="animation bottom-left">
              <MuiThemeProvider theme={animationTheme}>
                <Fab
                  variant="extended"
                  onClick={() => this.handleAnimationButtonClick()}
                >
                  {this.state.isAnimationOn ? <PauseIcon /> : <PlayArrowIcon />}
                  {Translate('Animation')}
                </Fab>
              </MuiThemeProvider>
            </div> */}

            {!this.state.isLoading ?
              <>
                <div className="info-panel fade-in" ref={this.totalBuildingConsumption}
                  style={{ display: this.state.arePanelsVisible ? 'unset' : 'none' }}>
                  <InfoPanelComponent
                    dataTypeId={MainSceneInfoPanel.TotalBuildingConsumption}
                    data={this.state.allData[0]}
                    isZoomIn={false}
                    onClickDetails={this.onClickDetails}
                    isDataUpdated={this.state.isDataUpdated}
                  />
                </div>
                <div className="info-panel fade-in" ref={this.energyDistribution}
                  style={{ display: this.state.arePanelsVisible ? 'unset' : 'none' }}>
                  <InfoPanelComponent
                    dataTypeId={MainSceneInfoPanel.EnergyDistribution}
                    data={this.state.allData[1]}
                    isZoomIn={false}
                    onClickDetails={this.onClickDetails}
                    openPopup={this.openChartPopup}
                    isDataUpdated={this.state.isDataUpdated}
                  />
                </div>
                <div className="info-panel fade-in" ref={this.weatherStation}
                  style={{ display: this.state.arePanelsVisible ? 'unset' : 'none' }}>
                  <InfoPanelComponent
                    dataTypeId={MainSceneInfoPanel.WeatherStation}
                    data={this.state.allData[2]}
                    isZoomIn={false}
                    onClickDetails={this.onClickDetails}
                    isDataUpdated={this.state.isDataUpdated}
                  />
                </div>
                <div className="info-panel fade-in" ref={this.common}
                  style={{ display: this.state.arePanelsVisible ? 'unset' : 'none' }}>
                  <InfoPanelComponent
                    dataTypeId={MainSceneInfoPanel.Common}
                    data={this.state.allData[3]}
                    isZoomIn={false}
                    onClickDetails={this.onClickDetails}
                    isDataUpdated={this.state.isDataUpdated}
                    clickOnPanel={this.openBarPopup}
                  />
                </div>
              </>
              : null}
            {/* <div className="info-panel" ref={this.animationPanel}>
              <AnimationPanelComponent
                dataTypeId={MainSceneInfoPanel.Animation}
                //data={this.state.allData[3]}
                isZoomIn={this.state.isZoomIn}
                onClickDetails={this.onClickDetails}
                isValueChanged={this.state.isDataUpdated}
              />
            </div> */}
          </>
        </div>

        <ScenePopupComponent
          isVisible={this.state.isPopupVisivle}
          content={this.state.popupContent}
          handleCancelButton={this.handleCancelPopupButton}
          title={this.state.popupTitle} />
      </>
    );
  }

}

const mapsStateToProps = (state: any) => {
  return {
    lang: state.common.lang,
    // animationState: state.common.animationState
  };
}

export default connect(mapsStateToProps, null)(MainSceneComponent);
